import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {UpdateActiveStep, UpdateOpenProfilePopup, UpdateOpenStepsList} from "../../../../redux/actions/tourActions";
import {countSuccessSteps, KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK, STEPS} from "../../helpers";
import {Tour} from "antd";

const TourSevenStep = () => {
    const dispatch = useDispatch();
    const activeStep = useSelector((state) => state.tour?.activeStep);
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if ([STEPS.SEVEN].includes(activeStep)) {
            setTimeout(() => {
                setIsOpen(true)
            }, 500)
        } else {
            setIsOpen(false)
        }
    }, [activeStep])

    const onHandleClickDontShow = () => {
        localStorage.setItem(KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK, true)
        window.dispatchEvent(
            new CustomEvent("localstorage-change", {
                detail: {key: KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK, value: true}
            })
        );
        document.querySelector('.menu__user-content')?.click();
        dispatch(UpdateOpenProfilePopup(true));
        dispatch(UpdateOpenStepsList(false));
    }

    const steps = [
        {
            title: countSuccessSteps() === 6 ? t('tour_step_7_complete') : t('tour_step_7'),
            description: countSuccessSteps() === 6 ? t('tour_step_7_complete_desc') : t('tour_step_7_desc'),
            target: () => document.querySelector(`.steps-list`),
            nextButtonProps: {
                children: <span>{countSuccessSteps() === 6 ? t('lets_get_work') : t('close')}</span>,
                onClick: () => {
                    if (countSuccessSteps() === 6) {
                        onHandleClickDontShow();
                    } else {
                        setIsOpen(false)
                    }
                }
            },
            placement: 'right'
        },
    ];

    return (
        <Tour
            indicatorsRender={(current, total) => (
                <span>
                      {current + 1} / {total}
                     </span>
            )}
            placement="left"
            open={isOpen}
            onClose={() => {
                dispatch(UpdateActiveStep(null));
                setIsOpen(false)
            }}
            steps={steps}
            gap={{radius: 12, offset: 4 }}
        />
    );
};

export default TourSevenStep;